// Copyright © 2006-2020 Lexbe Inc. All rights reserved.

export class TreeNode<T> {

  constructor(public data: T, public children: TreeNode<T>[] = [], public row: number = 0, public col: number = 0) { }

}

export class Tree<T> {

  constructor(public root?: TreeNode<T>) { }

  addRoot(data: T) {
    this.root = new TreeNode(data, [], 1, 1);
  }

  add(data: T, toNodeData: T) {
    const parent = toNodeData ? this.findBFS(toNodeData) : null;
    if (parent) {

      let childRow = parent.row;

      // When inserting a new row, adjust rows of existing nodes.
      if (parent.children.length > 0) {
        childRow = parent.children[parent.children.length - 1].row + 1;

        const queue = [this.root];
        while (queue.length) {
          const node = queue.shift();

          if (node.row >= childRow) {
            node.row++;
          }

          for (let i = 0; i < node.children.length; i++) {
            if (node.children[i].data === data) {
              node.children.splice(i, 1);
            } else {
              queue.push(node.children[i]);
            }
          }
        }
      }

      parent.children.push(new TreeNode(data, [], childRow, parent.col + 1));

    } else {
      if (!this.root) {
        this.addRoot(data);
      } else {
        return 'Root node is already assigned';
      }
    }
  }

  contains(data: T) {
    return this.findBFS(data) ? true : false;
  }

  directChildren(data: T): T[] {
    const parent = data ? this.findBFS(data) : null;

    if (parent == null) return null;

    const children: T[] = [];
    parent.children.map((x: TreeNode<T>) => { children.push(x.data) });
    return children;
  }

  findBFS(data: T) {

    const queue = [this.root];
    while (queue.length) {
      const node = queue.shift();
      if (node.data === data) {
        return node;
      }
      for (let i = 0; i < node.children.length; i++) {
        queue.push(node.children[i]);
      }
    }
    return null;
  }
}
